/* unplugin-vue-components disabled */import script from "./ExamScope.vue?vue&type=script&setup=true&lang=js"
export * from "./ExamScope.vue?vue&type=script&setup=true&lang=js"

import "./ExamScope.vue?vue&type=style&index=0&id=41456e3f&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41456e3f"]])

export default __exports__